import React from "react";
import "./Slider.css";

let Slider = (props) => {

    return (
        <input value={props.value} defaultValue={props.defaultValue} min={props.min} max={props.max} step={props.step} onChange={props.onChange} type="range" style={{width:"100%"}}/>
    );
}

export default Slider;